import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_flex_rec_on_fd",
  stages: {},
  goals: {},
  defaultStage: 1
});

export default utils;
